module.exports = __webpack_public_path__ + "static/output-01abc5c00121bab6bef2eb78d96eefb3.png";